jQuery(document).ready(function($) {
	var boxes = $(".expansion-wrapper");
	boxes.find(".link").on("click", function(e) {
		e.preventDefault();
		boxes.find(".link").not(this).closest('article').next().removeClass("open");
		$(this).closest('article').next().toggleClass("open");
	});


	/*
		Toggle expansion of text sections.
		Used on text-image-block, accordion-table and two-column-text
	*/
	$( '.expand_section' ).on( 'click', function( e ) {
		e.preventDefault();

		const $parent = $( this ).parents( '.expandable-section' );
		const $box    = $parent.find( '.expandable-content-box' );

		const currentHeight = $box.height();
		const isOpening     = $box.hasClass( 'is-closed' );
		let animateHeightTo = 0;

		$parent.toggleClass( 'is-open' );
		toggleText( $(this), isOpening );

		if ( isOpening ) {
			$box.removeClass( 'is-closed' );
			animateHeightTo = $box.innerHeight();
		} else {
			$box.addClass( 'is-closed' );
			animateHeightTo = $box.innerHeight();
			$box.removeClass( 'is-closed' );
		}

		// Animate box height.
		$box.css( 'height',  currentHeight );
		$box.animate({
			height: animateHeightTo,
		}, 250, function() {
			if ( ! isOpening ) {
				$box.addClass( 'is-closed' );
			}
			$box.removeAttr( 'style' );
		});

	});

	/*
		Change button text and icon.
	*/
	function toggleText( $btn, isOpening ) {
		const new_label = ( isOpening ) ? $btn.data( 'text-close' ) : $btn.data( 'text-open' );
		const hasIconClass = $btn.hasClass( 'icon-close') ||  $btn.hasClass( 'icon-plus');

		if ( new_label ) {
			$btn.text( new_label );
		}

		if ( hasIconClass ) {
			if ( isOpening ) {
				$btn.removeClass( 'icon-plus' ).addClass( 'icon-close' );
			} else {
				$btn.removeClass( 'icon-close' ).addClass( 'icon-plus' );
			}
		}
	}
});
